// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
import taskApi from '~/apis/task';
// Others
import { IBodyUpdate } from '~/utils/interface/common';
import { IFormTask, IQueryParamTask } from '~/utils/interface/task';
import { CREATE_TASK, DELETE_TASK, GET_DETAIL_TASK, GET_LIST_TASK, UPDATE_TASK } from '~/utils/constants/actionType';

export const getListTask = createAsyncThunk(GET_LIST_TASK, async (params: IQueryParamTask, { rejectWithValue }) => {
  try {
    const resp = await taskApi.getListTask(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createTask = createAsyncThunk(CREATE_TASK, async (body: FormData, { rejectWithValue }) => {
  try {
    const resp = await taskApi.createTask(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailTask = createAsyncThunk(GET_DETAIL_TASK, async (taskId: string, { rejectWithValue }) => {
  try {
    const resp = await taskApi.detailTask(taskId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateTask = createAsyncThunk(UPDATE_TASK, async (body: IBodyUpdate<IFormTask>, { rejectWithValue }) => {
  try {
    const resp = await taskApi.updateTask(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteTask = createAsyncThunk(DELETE_TASK, async (taskId: string, { rejectWithValue }) => {
  try {
    const resp = await taskApi.deleteTask(taskId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
